import './init/sentry';

import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const isCordovaApp = typeof window['cordova'] !== 'undefined';
const createRootElement = () => {
  const newRoot = document.createElement('app-root');
  document.body.appendChild(newRoot);
};

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
      if (!environment.production && module.hot) {
        module.hot.accept();
        module.hot.dispose(() => {
          try {
            const appRef = moduleRef.injector.get(ApplicationRef);

            // If we got here, the app is still alive. Let's find the root element.
            const componentRef = appRef.components[0];
            const rootElement = componentRef?.location.nativeElement;

            // Now destroy the app manually
            moduleRef.destroy();

            // If the destroy process removed the root element, put it back
            if ((rootElement && !document.body.contains(rootElement)) || !document.querySelector('app-root')) {
              createRootElement();
            }
          } catch {
            // If the injector is already destroyed, we land here. Clean the DOM.
            const oldRoot = document.querySelector('app-root');
            if (oldRoot) {
              oldRoot.remove();
            }
            createRootElement(); // Create a fresh one for the incoming module
          }
        });
      }
    })
    .catch((err) => console.log(err));
};

// Cordova app requires the 'deviceready' event before plugins will be usable.
// The current manual bootstrap process uses LoadConfigurationService which uses the

// Native HTTP plugin, so we need to ensure that the plugin is ready to
// be used prior to bootstrapping the app.
// Normally you would use the ionic paltform.ready() promise before commencing your app,
// so a possible alternate solution may be to move the LoadConfigurationService into that flow.
// But that will require more effort, so for now ensure the cordova app is ready
// prior to bootstrapping
if (isCordovaApp) {
  document.addEventListener('deviceready', () => bootstrap(), false);
} else {
  if (document.readyState === 'complete') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
}
